import { useMemo } from 'react'

import BoringAvatar from 'boring-avatars'

import { AppearanceStyle } from '@tribeplatform/design-system/types'
import {
  avatarSizeInPixel,
  type AvatarSize,
} from '@tribeplatform/react-ui-kit/Avatar'
import { useThemeContext } from '@tribeplatform/react-ui-kit/ThemeProvider'

import { InitialsAvatarPlaceholder } from './InitialsAvatarPlaceholder.js'
import { getPlaceholderColors, getAvatarPlaceholderVariant } from './utils.js'

export interface AvatarPlaceholderProps {
  name: string
  size: AvatarSize
  avatarStyle?: AppearanceStyle['avatars']
}

export const MemberAvatarPlaceholder = ({
  name,
  size,
  avatarStyle: avatarStyleProp,
}: AvatarPlaceholderProps) => {
  const { theme, style } = useThemeContext()

  const avatarStyle = avatarStyleProp ?? style.avatars

  const colors = useMemo(() => {
    return getPlaceholderColors({ theme, style: avatarStyle })
  }, [avatarStyle, theme])

  if (avatarStyle === 'initials') {
    return <InitialsAvatarPlaceholder name={name} size={size} />
  }

  return (
    <div className="rounded-avatar overflow-hidden">
      <BoringAvatar
        size={avatarSizeInPixel[size]}
        name={name}
        variant={getAvatarPlaceholderVariant(avatarStyle)}
        square
        /** Colors should be passed as hex codes to determine contrast */
        colors={colors}
      />
    </div>
  )
}
